import React, { createContext, useContext, useState, useCallback, useEffect } from 'react';

const ImportContext = createContext();

export const ImportProvider = ({ children }) => {
  const [imports, setImports] = useState([]);
  const [configurations, setConfigurations] = useState([]);
  const [schedule, setSchedule] = useState(null);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const [filters, setFilters] = useState({
    enterpriseId: '',
    layoutId: '',
    status: '',
    employeeId: '',
    startMonth: '',
    endMonth: ''
  });
  const [selectedTheme, setSelectedTheme] = useState(localStorage.getItem('theme') || 'lara-light-blue');
  const [baseId, setBaseId] = useState(localStorage.getItem('app_base_id') || null);

  // Load baseId from localStorage on init
  useEffect(() => {
    const storedBaseId = localStorage.getItem('app_base_id');
    if (storedBaseId && !baseId) {
      setBaseId(storedBaseId);
    }
  }, [baseId]);

  const clearError = useCallback(() => setError(null), []);

  const setErrorMessage = useCallback((message) => {
    setError(message);
    setTimeout(() => setError(null), 5000);
  }, []);

  const updateFilters = useCallback((newFilters) => {
    setFilters(prev => ({ ...prev, ...newFilters }));
  }, []);

  const resetFilters = useCallback(() => {
    setFilters({
      enterpriseId: '',
      layoutId: '',
      status: '',
      employeeId: '',
      startMonth: '',
      endMonth: ''
    });
  }, []);

  const updateTheme = useCallback((theme) => {
    setSelectedTheme(theme);
    localStorage.setItem('theme', theme);
  }, []);

  return (
    <ImportContext.Provider
      value={{
        // State
        imports,
        setImports,
        configurations,
        setConfigurations,
        schedule,
        setSchedule,
        loading,
        setLoading,
        error,
        filters,
        selectedTheme,
        baseId,
        setBaseId,

        // Methods
        clearError,
        setErrorMessage,
        updateFilters,
        resetFilters,
        updateTheme
      }}
    >
      {children}
    </ImportContext.Provider>
  );
};

export const useImport = () => {
  const context = useContext(ImportContext);
  if (!context) {
    throw new Error('useImport must be used within ImportProvider');
  }
  return context;
};

